<template>
  <el-card>
    <el-row>
      <el-upload
          class="upload-demo"
          :headers="{token}"
          :show-file-list="false"
          :on-change="uploadFile"
          :action="baseURL + '/meetSession/meetSession/' + activityType === '1' ? 'specialBrandImport/' : 'specialCompanyImport/' + id">
        <el-button size="small" type="primary">{{activityType === '1' ? '场次内特邀品牌导入' : '场次内特邀展商导入'}}</el-button>
      </el-upload>
    </el-row>
    <el-row class="common-margin">
      <el-table
          :data="tableData"
          :max-height="tableHeight"
          style="width: 100%"
          border
      >
        <el-table-column type="index" width="80px" align="center" label="序号"> </el-table-column>
        <el-table-column prop="contacts" align="center" label="联系人"></el-table-column>
        <el-table-column prop="logo" align="center" label="图片" width="140">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.logo"
                style="width: auto;height: 20px;"
                :src="scope.row.logo"
                :preview-src-list="scope.row.logoList"
                fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" label="手机号码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="weChat" align="center" label="微信号" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
                type="text"
                size="mini"
                @click="verify(scope.row.id, scope.row.status)"
            >审核</el-button
            >
            <el-button
                type="text"
                size="mini"
                @click="sessionDetail(scope.row.id)"
            >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes"
          :total="total"
      >
      </el-pagination>
    </el-row>

    <el-dialog width="460px" title="审核" :visible.sync="visible" :close-on-click-modal="false" :modal="false">
      <el-form ref="form" :model="form" class="add-form" :rules="rules">
        <el-form-item label="审核状态" label-width="120px" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="2">通过</el-radio>
            <el-radio label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>

export default {
  name: 'index',
  data () {
    return {
      baseURL: this.baseUrl,
      token: sessionStorage.getItem('token'),
      id: '',
      activityType: '',
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      form: {
        status: ''
      },
      rules: {
        status: {
          required: true,
          message: '请选择状态!',
          trigger: 'change'
        }
      },
      meetRecordId: '',
      visible: false
    }
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 600
  },
  methods: {
    async getPageList (id, type) {
      this.tableData = []
      this.total = 0
      this.activityType = type
      this.id = id
      let {data: res} = await this.$http.post('/meetSession/meetSession/getMeetRecordList', {
        meetSessionId: id,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach(item => {
          if (item.logo) {
            item.logoList = item.banner.split(',')
            item.logo = item.logo.split(',')[0]
          } else {
            item.logo = ''
            item.logoList = []
          }
        })
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList(this.id, this.activityType)
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList(this.id, this.activityType)
    },
    handleDelete (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/boutiqueActivities/boutiqueActivities/deleteAdvert', {id}).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList(this.id, this.activityType)
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    verify (id, status) {
      this.visible = true
      this.meetRecordId = id
      this.form.status = status
    },
    sessionDetail (id) {
      this.$emit('isShowDetail', id)
    },
    save () {
      this.$refs.form.validate(val => {
        if (val) {
          const params = {meetRecordId: this.meetRecordId, status: this.form.status}
          this.$http.post('/meetSession/meetSession/getMeetRecordStatus', params).then(res => {
            if (res.data.code === '200') {
              this.$message.success('审核成功!')
              this.getPageList(this.id, this.activityType)
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '审核失败'
            })
          })
          this.visible = false
        }
      })
    },
    uploadFile () {
      this.getPageList(this.id, this.activityType)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/meetSession/sessionList.vue